(function () {
    'use strict';

    angular
        .module(app.modules.scoring.name)
        .directive('xxStrokesGained', xxStrokesGained);

    function xxStrokesGained() {
        var result = {
            restrict: 'E',
            templateUrl: 'app/scoring/directives/strokes-gained.html',
            controller: XXStrokesGainedCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: { score: '=', hole: '=', change: '&' },
            replace: true
        };

        XXStrokesGainedCtrl.$inject = ['$scope', '$timeout', 'strokesGainedBaselineLookup', 'strokeGainedShotType'];
        function XXStrokesGainedCtrl($scope, $timeout, strokesGainedBaselineLookup, strokeGainedShotType) {
            var vm = this;

            // Properties
            Object.defineProperty(vm, 'shots', { get: getShots });
            Object.defineProperty(vm, 'player', { get: getPlayer });
            Object.defineProperty(vm, 'holeScore', { get: getHoleScore });
            vm.baselines = {}; 
            vm.strokeGainedShotType = Object.values(strokeGainedShotType.$metadata);
            vm.isInHole = true; // assume done

            // Core
            vm.$onInit = init;
            vm.addShot = addShot;
            vm.deleteShot = deleteShot;
            vm.calculateStrokesGained = calculateStrokesGained;

            // View Helpers
            vm.getNumberSuffix = getNumberSuffix;
            vm.isPenalty = isPenalty;
            vm.clearDistanceIfPenalty = clearDistanceIfPenalty;
            vm.className = className;
            vm.getTotal = getTotal;

            // Misc
            // scoreWatchAction
            // shotsWatch
            // shotsWatchAction
            // getShots
            // getPlayer
            // getHoleScore
            /////////////////////////////////////////

            var unwatchShots = angular.noop;

            // Core
            function init() {
                $scope.$watch('vm.holeScore', scoreWatchAction);
            }
            function addShot() {
                var shotCount = vm.shots.length,
                    current = vm.shots[shotCount - 1],
                    yards = vm.hole && vm.hole.yardage || null,
                    nextShot;

                nextShot = !shotCount ? { type: 'Tee', distance: yards }
                    : current.type == 'Green' || current.distance <= 100 ? { type: 'Green' }
                    : { type: 'Fairway' };

                vm.shots.push(nextShot);
            }
            function deleteShot(index) {
                vm.shots.splice(index, 1);
            }
            function calculateStrokesGained() {
                var last = -1;
                if (vm.baselines.$resolved)
                    angular.forEach(vm.shots.concat({ type: 'Done', distance: 0 }), handleShot);

                function handleShot(shot, index, array) {
                    var isPenalty = shot.type == 'Penalty',
                        prev = vm.shots[last] || {};

                    shot.baseline = getBaseline(shot.type, shot.distance);
                    shot.strokesGained = null;
                    if (prev.baseline != null && shot.baseline != null)
                        prev.strokesGained = prev.baseline - shot.baseline - (index - last);
                    if (!isPenalty)
                        last = index;
                }

                function getBaseline(type, distance) {
                    var result = vm.baselines[type + distance],
                        min = vm.baselines[type + 'Min'],
                        max = vm.baselines[type + 'Max'];
                    return type == 'Done' ? 0
                        : result != null ? result
                        : distance == null ? null
                        : distance < min ? min
                        : distance > max ? max
                        : null;
                }
            }

            // View Helpers
            function getNumberSuffix(index) {
                return index == 0 ? 'st' : index == 1 ? 'nd' : index == 2 ? 'rd' : 'th';
            }
            function isPenalty(shot) {
                return shot.type == 'Penalty';
            }
            function clearDistanceIfPenalty(shot) {
                shot.distance = !isPenalty(shot) ? shot.distance : null;
            }
            function className(name, index) {
                var ctrl = $scope.form[name + index] || {};
                return ctrl.$touched && ctrl.$invalid ? 'has-error' : null;
            }
            function getTotal() {
                return vm.shots.reduce(sum, 0);
                function sum(prev, curr) {
                    return prev + curr.strokesGained;
                }
            }

            // Misc
            function scoreWatchAction(newValue, oldValue) {
                vm.baselines = strokesGainedBaselineLookup(vm.player.handicap);
                vm.baselines.$promise.then(calculateStrokesGained);
                vm.isInHole = true;

                unwatchShots();
                unwatchShots = $scope.$watch(shotsWatch, shotsWatchAction);
                if (!vm.shots || vm.shots == undefined || vm.shots.length == 0)
                    $timeout(addShot);
            }
            
            function shotsWatch() {
                return vm.shots.map(map).join('');
                function map(shot) {
                    return "" + shot.type + shot.distance;
                }
            }

            function shotsWatchAction(newValue, oldValue) {
                vm.holeScore.gross = vm.shots.length;
                if (newValue != oldValue) {
                    vm.isInHole = false;
                    calculateStrokesGained();
                    vm.change();
                }
            }
            function getShots() {
                return vm.holeScore.strokesGained;
            }
            function getPlayer() {
                return vm.score.Temp.player;
            }
            function getHoleScore() {
                var score = vm.score,
                    gameHoleScores = score.gameHoleScores,
                    holeScores = score.holeScores,
                    list = gameHoleScores || holeScores;

                return list[vm.hole.number - 1];
            }
        }

        return result;
    }
})();